<template>
  <Teleport to="body">
    <div v-if="showLoading" class="overlay">
      <ProgressSpinner />
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
const showLoading = common.showLoading
</script>

<style>
.p-progress-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}
</style>
